<template>
  <div class="shoppe">
    <div class="query-form">
      <el-form label-position="right" label-width="100px">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="24" :lg="20" :xl="20">
            <el-row :gutter="10">
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="时间">
                  <el-date-picker
                    style="width:100%"
                    v-model="daterange"
                    type="daterange"
                    value-format="timestamp"
                    :editable="false"
                    :default-time="['00:00:00', '23:59:59']"
                    clearable
                  ></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="4" :xl="4">
            <el-button @click="search" type="primary">查询</el-button>
            <el-button @click="reset">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="tr">
      <el-button type="primary" @click="exportData">导出</el-button>
    </div>
    <el-table :data="tableData" v-loading="loading">
      <el-table-column prop="completionTime" label="时间">
        <template slot-scope="scope">
          {{ dateFormat(scope.row.completionTime) }}
        </template>
      </el-table-column>
      <el-table-column prop="appUserId" label="UserId"></el-table-column>
      <el-table-column prop="vendorName" label="店铺"></el-table-column>
      <el-table-column prop="agreeContact" label="是否同意联系"></el-table-column>
      <el-table-column prop="phoneNumber" label="联系方式"></el-table-column>
      <el-table-column prop="salesSituation" label="最近卖货如何"></el-table-column>
      <el-table-column prop="unpleasantUserExperience" label="卖货体验不好地方"></el-table-column>
      <el-table-column prop="mainSellingPlace" label="在哪里卖货最多"></el-table-column>
      <el-table-column prop="mainSellingBrand" label="主要卖的品牌"></el-table-column>
      <el-table-column prop="desiredSolution" label="希望IMapp解决问题"></el-table-column>
      <el-table-column prop="mainSellingPoint" label="卖货主要诉求"></el-table-column>
      <el-table-column prop="mainPurchasingChannel" label="主要进货渠道"></el-table-column>
      <el-table-column prop="experienceScore" label="体验分数"></el-table-column>
      <el-table-column prop="recommendedToFriendScore" label="是否推荐给朋友"></el-table-column>
      <el-table-column prop="feedback" label="意见反馈"></el-table-column>
      <el-table-column prop="remark" label="备注">
        <template slot-scope="scope">
          <p v-if="scope.row.remark">{{ scope.row.remark }}</p>
          <el-link type="primary" @click="addRemark(scope.row)">{{ scope.row.remark ? '添加' : '编辑' }}</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="tr"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryForm.pageNo"
      :page-sizes="[10, 25, 50, 100]"
      :page-size="queryForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>

    <el-dialog append-to-body title="备注" :visible.sync="dialogVisible" width="500px">
      <el-input v-model.trim="form.remark" :rows="6" maxlength="1000"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import utils from '@/utils/util';
import { downloadUrlFile } from '@/utils/functions'
import {
  getQuestionnaireList,
  questionnaireRemark,
  exportQuestionnaireList,
} from "./api";

export default {
  components: {
  },
  data() {
    return {
      daterange: [],
      queryForm: {
        pageNo: 1,
        pageSize: 25,
      },
      tableData: [],
      total: 0,
      loading: false,
      dialogVisible: false,
      form: {
        id: null,
        remark: '',
      },
    };
  },
  created() {
    this.getTableData();
  },
  methods: {
    search() {
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    reset() {
      this.daterange = [];
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    getTableData() {
      this.loading = true;
      getQuestionnaireList({
        ...this.queryForm,
        startTime: this.daterange[0] || null,
        endTime: this.daterange[1] || null,
      }).then(res => {
        if (res.data && res.data.data) {
          this.total = res.data.data.total;
          this.tableData = res.data.data.list;
        }
        this.loading = false;
      })
    },
    handleSizeChange(pageSize) {
      this.queryForm.pageSize = pageSize;
      this.getTableData();
    },
    handleCurrentChange(pageNo) {
      this.queryForm.pageNo = pageNo;
      this.getTableData();
    },
    addRemark(row) {
      this.form.id = row.id;
      this.form.remark = row.remark;
      this.dialogVisible = true;
    },
    submit() {
      if (this.repeatSubmit) {
        return;
      }
      this.repeatSubmit = true;
      questionnaireRemark(this.form).then(res => {
        if (res.data && res.data.success) {
          this.$message.success('操作成功');
          this.dialogVisible = false;
          this.getTableData();
        }
        this.repeatSubmit = false;
      }).catch(() => {
        this.repeatSubmit = false;
      })
    },

    dateFormat(time) {
      if (!time) {
        return '';
      }
      return utils.dateFormat(new Date(time), 'yyyy-MM-dd hh:mm:ss');
    },
    exportData() {
      exportQuestionnaireList({
        startTime: this.daterange[0] || null,
        endTime: this.daterange[1] || null,
      }).then(res => {
        if (res.data && res.data.data) {
          this.$message.success('导出成功');
          downloadUrlFile(res.data.data);
        }
      })
    },
  },
};
</script>
<style lang="less" scoped>
.shoppe {
  padding: 20px;
}
.tr {
  margin-top: 10px;
  text-align: right;
}
.ml10 {
  margin-left: 10px;
}
</style>
